import { configureStore } from '@reduxjs/toolkit';
import authSlice from '@redux/auth/slice';
//TODO: DON'T REMOVE ==> import slice here
import storage from 'redux-persist/lib/storage';
import layoutsSlice from '@redux/layouts/slice';
import { persistReducer, persistStore } from 'redux-persist';
import { referencesApi } from '@redux/references/slice';
import customersSlice from '@redux/customers/slice';
import configSlice from '@redux/config/slice';
import referenceDataSlice from '@redux/referenceData/slice';
import headerMenusSlice from '@redux/headerMenus/slice';
import footerMenusSlice from '@redux/footerMenus/slice';
import usersSlice from '@redux/users/slice';
import systemConfigsSlice from '@redux/systemConfigs/slice';
import vendorFfmsSlice from '@redux/vendorFfms/slice';
import partnersSlice from '@redux/partners/slice';
import ordersSlice from '@redux/orders/slice';
import variantRelatedSlice from '@redux/variantRelated/slice';
import productVariantsSlice from '@redux/productVariants/slice';
import orderReturnHistoriesSlice from '@redux/orderReturnHistories/slice';
import orderHistoriesSlice from '@redux/orderHistories/slice';
import orderBatchesSlice from '@redux/orderBatches/slice';
import ordersReadyToPickSlice from '@redux/ordersReadyToPick/slice';
import ordersPickingSlice from '@redux/ordersPicking/slice';
import ordersDetailSlice from '@redux/ordersDetail/slice';
import ordersPickingListSlice from '@redux/ordersPickingList/slice';
import locationsSlice from '@redux/locations/slice';
import ordersReturnSlice from '@redux/ordersReturn/slice';
import modalSlice from '@redux/modal/slice';
import transferOrdersSlice from '@redux/transferOrders/slice';
import transferOrdersBatchSlice from '@redux/transferOrdersBatch/slice';
import transferConfirmedPickSlice from '@redux/transferConfirmedPick/slice';
import itemOrdersSlice from '@redux/itemOrders/slice';
import bannedCustomersSlice from '@redux/bannedCustomers/slice';
import chainStoresSlice from '@redux/chainStores/slice';
import inventoriesSlice from '@redux/inventories/slice';
import inProcessOrdersSlice from '@redux/inProcessOrders/slice';
import ordersAwaitingConfirmSlice from '@redux/ordersAwaitingConfirm/slice';
import orderBatchesPickingSlice from '@redux/orderBatchesPicking/slice';
import ordersExchangeSlice from '@redux/ordersExchange/slice';
import ordersPendingForExchangeSlice from '@redux/ordersPendingForExchange/slice';
import deliverySlice from '@redux/delivery/slice';
import ordersTabTryBuySlice from '@redux/ordersTabTryBuy/slice';
import locationStockChangesSlice from '@redux/locationStockChanges/slice';
import rolePermissionsSlice from '@redux/rolePermissions/slice';
import rolePermissionGroupsSlice from '@redux/rolePermissionGroups/slice';
import rolesSlice from '@redux/roles/slice';

const getPersistConfig = (key) => ({
  key,
  storage,
});

export const store = configureStore({
  reducer: {
    auth: authSlice,

    customers: customersSlice,
    config: configSlice,
    referenceData: referenceDataSlice,
    headerMenus: headerMenusSlice,
    footerMenus: footerMenusSlice,
    users: usersSlice,
    vendorFfms: vendorFfmsSlice,
    partners: partnersSlice,
    systemConfigs: systemConfigsSlice,
    orders: ordersSlice,
    variantRelated: variantRelatedSlice,
    productVariants: productVariantsSlice,
    orderReturnHistories: orderReturnHistoriesSlice,
    orderHistories: orderHistoriesSlice,
    orderBatches: orderBatchesSlice,
    ordersReadyToPick: ordersReadyToPickSlice,
    ordersPicking: ordersPickingSlice,
    ordersDetail: ordersDetailSlice,
    ordersPickingList: ordersPickingListSlice,
    locations: locationsSlice,
    ordersReturn: ordersReturnSlice,
    modal: modalSlice,
    transferOrders: transferOrdersSlice,
    transferOrdersBatch: transferOrdersBatchSlice,
    transferConfirmedPick: transferConfirmedPickSlice,
    itemOrders: itemOrdersSlice,
    bannedCustomers: bannedCustomersSlice,
    chainStores: chainStoresSlice,
    inventories: inventoriesSlice,
    inProcessOrders: inProcessOrdersSlice,
    ordersAwaitingConfirm: ordersAwaitingConfirmSlice,
    orderBatchesPicking: orderBatchesPickingSlice,
    ordersExchange: ordersExchangeSlice,
    ordersPendingForExchange: ordersPendingForExchangeSlice,
    delivery: deliverySlice,
    ordersTabTryBuy: ordersTabTryBuySlice,
    locationStockChanges: locationStockChangesSlice,
    rolePermissions: rolePermissionsSlice,
    rolePermissionGroups: rolePermissionGroupsSlice,
    roles: rolesSlice,
    layouts: persistReducer(getPersistConfig('layouts'), layoutsSlice),
    //TODO: DON'T REMOVE ==> register reducer here
    [referencesApi.reducerPath]: referencesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      //TODO: DON'T REMOVE ==> register middleware here
      .concat(referencesApi.middleware),
});
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// setupListeners(store.dispatch);
